import React from 'react';
import SubLink from '../../Route/SubLink';
import { EmployeeManageData } from '../../Route/SubLinkJSON';

function Employeemanage() {
  return (
    <>
  <SubLink sublinks={EmployeeManageData} />
    </>
  )
}

export default Employeemanage;
